import React from 'react';
export function PresentingSection() {
  return <section aria-labelledby="presentamos" className="bg-lime text-ink" data-id="element-159" data-mp="1gvj3uz264kuv">
      <div className="mx-auto max-w-5xl px-5 py-20 text-center sm:py-28" data-id="element-160" data-mp="o625nnqengds">
        <p className="font-display text-sm font-extrabold uppercase tracking-[0.25em]" data-id="element-161" data-mp="jd9396iesk4v">Presentamos</p>
        <h2 id="presentamos" className="mt-5 font-display text-5xl font-black uppercase leading-[0.95] sm:text-7xl" data-id="element-162" data-mp="fd8o1jnhk4wr">
          Cómo perder grasa en 45 días
        </h2>
        <p className="mx-auto mt-6 max-w-2xl font-display text-2xl font-bold sm:text-3xl" data-id="element-163" data-mp="5e9fs26mubaa">
          El sistema completo para convertir conocimiento en acción.
        </p>
        <p className="mx-auto mt-4 max-w-xl text-lg font-medium text-ink/75" data-id="element-164" data-mp="fgb8z9bpum9">
          Un e-book práctico diseñado para acompañarte durante 45 días.
        </p>

        <div className="mx-auto mt-14 max-w-2xl space-y-3 text-left text-lg font-medium sm:text-xl" data-id="element-165" data-mp="1us65ji3lt5u6">
          <p className="text-ink/70" data-id="element-166" data-mp="1qsnmysz996ui">No se trata solamente de decirte qué comer.</p>
          <p className="text-ink/70" data-id="element-167" data-mp="asnqggghl6m7">No se trata solamente de darte una rutina.</p>
          <p className="text-ink/70" data-id="element-168" data-mp="fs0g18yqsrsh">Y tampoco se trata de prometerte una transformación imposible.</p>
          <p className="pt-4 font-display text-3xl font-black uppercase sm:text-4xl" data-id="element-169" data-mp="1sscy4zgkzj0">Se trata de darte una estructura.</p>
        </div>
      </div>
    </section>;
}